import $ from 'jquery';
const wishlistModule = (() => {
    function removeURLParameter(url, parameter) {
        //prefer to use l.search if you have a location/link object
        var urlparts= url.split('?');
        if (urlparts.length>=2) {

            var prefix= encodeURIComponent(parameter)+'=';
            var pars= urlparts[1].split(/[&;]/g);

            //reverse iteration as may be destructive
            for (var i= pars.length; i-- > 0;) {
                //idiom for string.startsWith
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }

            url= urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
            return url;
        } else {
            return url;
        }
    }

    function addToWishList(code, isOneSize) {
        let size = '';
        let email = '' ;
        let sectionURL = '';
        let sessionID = '';
        let canGuestsHaveFavorites = false;
        let wishlistTagId = '';
        let b_id = 'fb_plp_'+code;
        let _btn = $("#"+b_id);

        if (isOneSize == 'true') {
            size = 'all';
        } else if ($('#pdp-sizes input:checked').length) {
            size = $('#pdp-sizes input:checked').val()
        }
        if (typeof window.rcProps.plp != "undefined") {
            email = window.rcProps.plp.email;
            sectionURL = window.rcProps.plp.sectionurl;
            sessionID = window.rcProps.plp.sessionID;
            wishlistTagId = window.rcProps.plp.wishlistTagId;
            canGuestsHaveFavorites = window.rcProps.plp.canGuestsHaveFavorites;
        } else if (typeof window.rcProps.pdp != "undefined") {
            _btn = $("#add-to-wishlist-link");
            email = window.rcProps.pdp.email;
            sectionURL = window.rcProps.pdp.sectionURL;
            sessionID = window.rcProps.pdp.sessionId;
            canGuestsHaveFavorites = window.rcProps.pdp.canGuestsHaveFavorites;
        }
        let department = window.rcProps.department;

        var wishlistTagIdPair = wishlistTagId+'='+b_id;
        var wishlistReturnUrl = window.location.pathname+window.location.search;
        if(wishlistReturnUrl.includes(wishlistTagId)) wishlistReturnUrl = removeURLParameter(wishlistReturnUrl, wishlistTagId);
        if(wishlistReturnUrl.includes('?')) wishlistReturnUrl = wishlistReturnUrl + '&' + wishlistTagIdPair;
        else wishlistReturnUrl = wishlistReturnUrl + '?' + wishlistTagIdPair;

        var signInCreateAccountPage = '/fw/addToWishList.jsp?code=' + code + '&size=' + size + '&sectionURL=' + encodeURIComponent(sectionURL) + '&sessionID=' + sessionID + '&redirect=true&returnUrl='+encodeURIComponent(wishlistReturnUrl);
        var signInCreateAccount = '/fw/Login.jsp?page=' + encodeURIComponent(signInCreateAccountPage);

        $("#wishlistLogin_a").attr("href", signInCreateAccount);

        if (!email && !canGuestsHaveFavorites) {
            $.modal({
                url: "/fw/content/wishlist/login?href=" + encodeURIComponent(signInCreateAccount),
                type: "top",
                triggerOpen: true
            });
            return;
        }


        var data = $.param({
            code : code,
            sectionURL : sectionURL,
            sessionID : sessionID,
            "size" : size,
            email : email,
            d: window.rcProps.department,
        });

        var postUrl = "/fw/addToWishList.jsp";

        if (_btn.hasClass("favorite-button--active")) {
            _btn.removeClass("favorite-button--active");
            postUrl = "/fw/EditWishlist.jsp";
            data = $.param({
                code: code,
                size: size,
                email: email,
                d: department,
            });
        } else {
            var wishlistCountUpdater = new window.WishlistCountUpdater();
            if (wishlistCountUpdater.showWishListMaxRestrictionPopup()) {
                return;
            } else {
                _btn.addClass("favorite-button--active");
            }
        }

        updateFavoritesMessage(_btn);

        $.post(postUrl, data, function(ajaxResponse){
            try {
                var responseObject = JSON.parse(ajaxResponse.trim());
                if (responseObject.maxPopup) {
                    $("#wishlist_item_count").data('count', responseObject.data);
                    $("#wishlist_item_count").data('limit', responseObject.limit);
                    $('#wish-max-popup-div').empty().append(responseObject.maxPopup);
                    $.modal({triggerOpen: true, open: "restrict-favorites"});
                    return;
                }
            }catch (e) {}
            // wishlist button in pdp
            var wishlistNotifyText = $("#wishlistNotifyText");
            let wishListText = $(".wishListBlock__text");

            if (_btn.hasClass("favorite-button--active")) {
                wishlistNotifyText.text(wishlistNotifyText.data("wishlistremoved"));
                wishListText.text(wishListText.data("wishlistremoved"));
                if(typeof gaUpdateWishList === 'function'){
                    gaUpdateWishList('remove',code);
                }
                if (typeof insertCordialUpdateWishList === 'function') {
                    insertCordialUpdateWishList('remove', code);
                }
                if(typeof  taboolaWishListAction === 'function') {
                    taboolaWishListAction("add", code);
                }
            } else {
                wishlistNotifyText.text(wishlistNotifyText.data("wishlistadded"));
                wishListText.text(wishListText.data("wishlistadded"));
                if(typeof gaUpdateWishList === 'function'){
                    gaUpdateWishList('add',code);
                }
                if (typeof insertCordialUpdateWishList === 'function') {
                    insertCordialUpdateWishList('add', code);
                }
                if(typeof iPinYouHeartItem === 'function'){
                    iPinYouHeartItem(code);
                }
                if(typeof insertRTBHouseHeartItem === 'function'){
                    insertRTBHouseHeartItem(code);
                }
                if(typeof taboolaWishListAction === 'function') {
                    taboolaWishListAction("remove", code);
                }
            }

            var wishlistCountUpdater = new WishlistCountUpdater();
            wishlistCountUpdater.updateCount();

        });

    }

    function updateFavoritesMessage(favBtn){
        if(!favBtn || favBtn.length == 0)
            return ;
        var notificationContainer = '.js-favorite-notify'

        var favMessage = favBtn.data('favorite-message');
        var unFavMessage = favBtn.data('unfavorite-message');
        var favNotification = favBtn.data('favorite-notification');
        var unFavNotification = favBtn.data('unfavorite-notification');
        var isFav = !favBtn.hasClass('favorite-button--active');

        if(isFav) {
            favBtn.find('.u-screen-reader').html(favMessage);
            favBtn.parent().find(notificationContainer).html(unFavNotification);
        } else {
            favBtn.find('.u-screen-reader').html(unFavMessage);
            favBtn.parent().find(notificationContainer).html(favNotification);
        }
    }


    function checkWihlistTagId(){
        var wishlistTagId = window.rcProps.plp.wishlistTagId;
        if(window.location.search.includes(wishlistTagId)){
            var urlparts= window.location.search.split('?');
            if (urlparts.length>=2) {
                var pars= urlparts[1].split(/[&;]/g);
                for (var i=0;i<pars.length;i++){
                    console.log('pars[i] = '+pars[i]);
                    if(pars[i].includes(wishlistTagId)){
                        var pair = pars[i].split('=');
                        if (pair.length>0) {
                            console.log('pair[1] = '+pair[1]);
                            console.log('document.getElementById(pair[1]) = '+document.getElementById(pair[1]));
                            if(document.getElementById(pair[1])){
                                console.log('scrollIntoView');
                                document.getElementById(pair[1]).scrollIntoView();
                            }
                        }
                    }
                }
            }
        }
    }

    return {
        checkWihlistTagId : checkWihlistTagId,
        bindWishListEvent: function() {
          var $favButton = $('.js-fav-button');
          $favButton.each(function() {
            if($(this).data('favButtonEvent') === true) {
              return
            }
            $(this).data('favButtonEvent', true)
            $(this).click(function (e) {
              var code = $(this).data('code');
              var oneSize = $(this).data('oneSize');
              addToWishList(code, oneSize);
            });
          })
        },
        bindPDPWishListEvent: function(){
            $('#add-to-wishlist-link').click(function(event) {
                (event.preventDefault) ? event.preventDefault() : event.returnValue = false;
                var code = window.rcProps.pdp.code;
                addToWishList(code, $('#pdp-sizes input:checked') === "all");
            });
        },
        updateItemCount: function(data){
            $('.js-item-count').html($('.js-item-count', $(data)).html());
        }
    };
})();

export default wishlistModule;



// WEBPACK FOOTER //
// ./src/scripts/modules/wishlist.js